export default __webpack_public_path__ + "static/media/img_muslinTwoBunnyEarsBib_rg_p.52215169.jpg";